import { render } from "./DeleteResourceModal.vue?vue&type=template&id=4ee0862c"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteResourceModal.vue"]])

export default __exports__